<div class="free-plan-extend-popup position-relative">
    <div *ngIf="plan_extend_popup_type === freePlanExtendPopType.Initial" class="free-plan-extend-popup-header padding-bottom">
        <div class="position-absolute  cursor-pointer close-button mat-icon-16" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </div>
        <div class="pad-32-top margin-auto text-center pad-8-bottom font-14 font-bold pad-32">
            Here’s a special offer just for you!
        </div>
        <div class="avatar flex-centered-container">
            <img src="/assets/icons/gift.svg">
        </div>
    </div>
    <div *ngIf="plan_extend_popup_type === freePlanExtendPopType.Success" class="free-plan-extend-popup-header padding-bottom">
        <div class="position-absolute  cursor-pointer close-button mat-icon-16" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </div>
        <div class="pad-32-top margin-auto text-center pad-8-bottom font-14 font-bold pad-32">
            Success! Your Free Plan is Extended!
        </div>
        <div class="avatar flex-centered-container">
            <img src="/assets/icons/extend-success.svg">
        </div>
    </div>
    <div *ngIf="plan_extend_popup_type === freePlanExtendPopType.Failed" class="free-plan-extend-popup-header padding-bottom">
        <div class="position-absolute  cursor-pointer close-button mat-icon-16" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </div>
        <div class="pad-32-top margin-auto text-center pad-8-bottom font-14 font-bold pad-32">
            Oops! Something Went Wrong
        </div>
        <div class="avatar flex-centered-container">
            <img src="/assets/icons/extended-failed.svg">
        </div>
    </div>
    <div  *ngIf="plan_extend_popup_type === freePlanExtendPopType.Initial" class="font-12 margin-auto text-center pad-32">
        <div class="pad-8-bottom font-14 free-plan-extend-heading font-bold">
            Extend Your Free Plan by {{free_plan_extension_days}} More Days!
        </div>
        <div>
            We appreciate you using our service, and as a token of our gratitude, we're offering you an extra {{free_plan_extension_days}} days on your free plan.
            Enjoy more time to explore all the features and benefits.
        </div>
        <!-- <div class="extended-date chamfer margin-top">
            <p class="pad-4">Your extended plan will expire on {{subscription_end_date}}</p>
        </div> -->
        <div class="center-label align-items-center margin-32-top">
            <button mat-flat-button class="border-radius-8 ut-pro-button gradient mat-focus-indicator
                mat-button mat-button-base mat-flat-button mat-accent full-width" (click)="loginShareIndia()">
                Extend Plan for {{free_plan_extension_days}} Days
            </button>
        </div>
    </div>
    <div  *ngIf="plan_extend_popup_type === freePlanExtendPopType.Success" class="font-12 margin-auto text-center pad-32">
        <div class="pad-8-bottom font-14 free-plan-extend-heading font-bold">
            Enjoy {{free_plan_extension_days}} More Days on Us!
        </div>
        <div>
            We're excited to let you know that your free plan has been successfully extended for another {{free_plan_extension_days}} days. 
            Dive back in and make the most of your extended access!
        </div>
        <div class="center-label align-items-center margin-32-top">
            <button mat-flat-button class="border-radius-8 ut-pro-button gradient mat-focus-indicator
                mat-button mat-button-base mat-flat-button mat-accent full-width" (click)="closeDialog()">
                Continue
            </button>
        </div>
    </div>
    <div  *ngIf="plan_extend_popup_type === freePlanExtendPopType.Failed" class="font-12 margin-auto text-center pad-32">
        <div class="pad-8-bottom font-14 free-plan-extend-heading font-bold">
            We Couldn't Extend Your Free Plan
        </div>
        <div>
            Unfortunately, we encountered an issue while trying to extend your free plan. 
            Please try again later or contact our support team for assistance. 
            We apologize for the inconvenience.
        </div>
        <div class="center-label align-items-center margin-32-top">
            <button mat-flat-button class="border-radius-8 ut-pro-button gradient mat-focus-indicator
                mat-button mat-button-base mat-flat-button mat-accent full-width" (click)="loginShareIndia()">
                Try Again
            </button>
        </div>
    </div>
</div>